// extracted by mini-css-extract-plugin
export default {"status":"Status-module__status__j2hVk","icon":"Status-module__icon__hyf-V","invalid":"Status-module__invalid__H77QT","valid":"Status-module__valid__Uc+v2"};